import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import App from './App'
import { I18nProvider } from './i18n'
import './index.css'

// Après un déploiement, les anciens chunks JS (hash) n'existent plus : un import
// lazy échoue ("Failed to fetch dynamically imported module"). On recharge la
// page une seule fois (garde anti-boucle) pour récupérer la nouvelle version.
window.addEventListener('vite:preloadError', () => {
  if (!sessionStorage.getItem('pf_chunk_reloaded')) {
    sessionStorage.setItem('pf_chunk_reloaded', '1')
    window.location.reload()
  }
})

// C2 - React Query : cache + invalidation ciblee. Evite de recharger 5000
// prospects a chaque action (drag / filtre / suppression) sur CRM.
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,         // 1 min : on ne refetch pas systematiquement
      gcTime: 5 * 60_000,        // garbage collect au bout de 5 min
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <I18nProvider>
          <App />
        <Toaster
        position="top-right"
        toastOptions={{
          style: {
            background: '#1e293b',
            color: '#f1f5f9',
            border: '1px solid #334155',
          },
          success: { iconTheme: { primary: '#3b82f6', secondary: '#0f172a' } },
          error: { iconTheme: { primary: '#ef4444', secondary: '#0f172a' } },
        }}
      />
        </I18nProvider>
      </QueryClientProvider>
    </BrowserRouter>
  </React.StrictMode>
)

// L'app a chargé : on relâche la garde anti-boucle pour pouvoir récupérer un
// prochain déploiement (mais pas en boucle sur une vraie panne immédiate).
setTimeout(() => sessionStorage.removeItem('pf_chunk_reloaded'), 10000)
